















































import { Component, mixins, Ref } from 'nuxt-property-decorator'
import { gsap, ScrollTrigger, ScrollSmoother } from 'gsap'

import DeviceMixin from '@/mixins/device'
import PageTransitionMixin from '@/mixins/transitions/page'

interface ListItem {
  id: string
  name: string
  desc: string
}

@Component
export default class PageAbout extends mixins(PageTransitionMixin, DeviceMixin) {
  isDesktop: boolean

  @Ref('left') columnLeft: HTMLElement
  @Ref('right') columnRight: HTMLElement
  @Ref('rightInner') columnRightInner: HTMLElement

  onScrollTween: GSAPTween = null
  isListJuryVisible = true
  isListExpertsVisible = false

  get jury() {
    return this.$t('about.jury.list') as unknown as ListItem[]
  }

  get experts() {
    return this.$t('about.experts.list') as unknown as ListItem[]
  }

  get showListJury() {
    return this.isDesktop || this.isListJuryVisible
  }
  set showListJury(visible: boolean) {
    this.isListJuryVisible = visible
    this.isListExpertsVisible = !this.isListJuryVisible
  }

  get showListExperts() {
    return this.isDesktop || this.isListExpertsVisible
  }
  set showListExperts(visible: boolean) {
    this.isListExpertsVisible = visible
    this.isListJuryVisible = !this.isListExpertsVisible
  }

  head() {
    const title = this.$t('about.meta_title')
    const description = this.$t('about.meta_description')
    const image = `${this.$config.baseUrl}/assets/images/about.jpg`

    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'og:description', property: 'og:description', content: description },
        { hid: 'og:image', property: 'og:image', content: image },
        // Twitter Card
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid: 'twitter:description', name: 'twitter:description', content: description },
        { hid: 'twitter:image', name: 'twitter:image', content: image }
      ]
    }
  }

  onScrollReady(scrollSmoother: ScrollSmoother) {
    ScrollTrigger.matchMedia({
      [this.$breakpoints.mq('lg')]: () => {
        // right column parallax
        this.onScrollTween = gsap.to(this.columnRightInner, {
          y: () => Math.min(0, window.innerHeight - (this.columnRightInner.getBoundingClientRect().bottom + scrollSmoother.scrollTrigger.scroll())),
          scrollTrigger: {
            start: 'top top',
            end: 'bottom bottom',
            scrub: true,
            invalidateOnRefresh: true,
            pin: this.columnRight,
            pinSpacing: false
          }
        })

        return this.onScrollTween.kill
      }
    })
  }

  beforeDestroy() {
    this.onScrollTween?.kill()
  }
}
